import ArrowFillDown from '@atom-web/icons-24/jsx/ArrowFillDown'
import Baby from '@atom-web/icons-24/jsx/Baby'
import { Popover } from '@atom-web/macros'
import {
	Button,
	Column,
	Divider,
	Flex,
	Input,
	Row,
	Text,
} from '@atom-web/micros'
import { useCallback, useState } from 'react'

import { useComponentDidMount } from './helper'

const TravelDetailRoom = ({
	selectetype,
	onchangee,
	onCloseModal,
	Details = '',
}) => {
	const ErrorMessage = {
		childAgeNotPresent: 'Please enter age details',
		infantCountInvalid: 'Infant count should not be greather than adult count',
		roomCapacityFull: 'You cannot add more than 6 people in a room',
		maxPeopleAllowed: 'Maximum 9 people allowed in a trip',
	}
	const [maxPeopleAllowed, setmaxPeopleAllowed] = useState(false)
	const [roomCapacityFull, setroomCapacityFull] = useState(false)
	const [infantCountInvalid, setinfantCountInvalid] = useState(false)
	const [childAgeNotPresent, setchildAgeNotPresent] = useState(false)
	const [roomDetails, setroomDetails] = useState([
		{ room: 1, adultCount: 2, childAges: [], childrenVal: 0 },
	])
	const [selectedRoom, setselectedRoom] = useState(0)
	const [selectedChildAge, setSelectedChildAge] = useState({
		show: false,
		roomIndex: 0,
		selfIndex: 0,
	})
	useComponentDidMount(() => {
		if (Details != '') {
			setroomDetails(Details)
		}
	})
	const addRoomFunction = useCallback(() => {
		const adultCount = roomDetails.reduce(
			(previousValue, currentValue) => previousValue + currentValue.adultCount,
			0,
		)
		const childCount = roomDetails.reduce(
			(previousValue, currentValue) => previousValue + currentValue.childrenVal,
			0,
		)
		const Pushvalue = [...roomDetails]
		if (roomDetails.length <= 5 && adultCount + childCount <= 7) {
			if (
				Pushvalue[selectedRoom].childAges.length ==
				Pushvalue[selectedRoom].childrenVal
			) {
				Pushvalue.push({
					room: 1,
					adultCount: 2,
					childAges: [],
					childrenVal: 0,
				})
				setroomDetails(Pushvalue)
				setselectedRoom(roomDetails.length)
			} else {
				setchildAgeNotPresent(true)
			}
		} else if (!adultCount + childCount <= 7) {
			setmaxPeopleAllowed(true)
		}
	}, [roomDetails])

	const deleteRoomFunction = () => {
		const data = [...roomDetails]
		data.splice(selectedRoom, 1)
		setroomDetails(data)
		setmaxPeopleAllowed(false)

		if (selectedRoom === 0) {
			setselectedRoom(roomDetails.length - 2)
		} else if (roomDetails.length > 1) {
			setselectedRoom(selectedRoom - 1)
		}
		setinfantCountInvalid(false)
		setroomCapacityFull(false)
		setmaxPeopleAllowed(false)
		setchildAgeNotPresent(false)
	}
	const addAdultFunction = () => {
		const adultCount = roomDetails.reduce(
			(previousValue, currentValue) => previousValue + currentValue.adultCount,
			0,
		)
		const childCount = roomDetails.reduce(
			(previousValue, currentValue) => previousValue + currentValue.childrenVal,
			0,
		)
		if (adultCount + childCount + 1 <= 9) {
			roomDetails.map((e, index) =>
				index == selectedRoom && e.adultCount + e.childrenVal >= 6
					? setroomCapacityFull(true)
					: null,
			)
			setroomDetails(
				roomDetails.map((item, index) =>
					index == selectedRoom && item.adultCount + item.childrenVal < 6
						? { ...item, adultCount: item.adultCount + 1 }
						: item,
				),
			)
			if (!childCount < adultCount) {
				setinfantCountInvalid(false)
			}
		} else {
			setmaxPeopleAllowed(true)
		}
	}
	const decreaseAdultFunction = () => {
		setroomDetails(
			roomDetails.map((item, index) =>
				index == selectedRoom && item.adultCount >= 2
					? { ...item, adultCount: item.adultCount - 1 }
					: item,
			),
		)
		setinfantCountInvalid(false)
		setroomCapacityFull(false)
		setmaxPeopleAllowed(false)
		setchildAgeNotPresent(false)
	}
	const addChildFunction = () => {
		const adultCount = roomDetails.reduce(
			(previousValue, currentValue) => previousValue + currentValue.adultCount,
			0,
		)
		const childCount = roomDetails.reduce(
			(previousValue, currentValue) => previousValue + currentValue.childrenVal,
			0,
		)
		if (childCount < adultCount && adultCount + childCount <= 9) {
			roomDetails.map((e, index) =>
				index == selectedRoom && e.adultCount + e.childrenVal >= 6
					? setroomCapacityFull(true)
					: null,
			)
			setroomDetails(
				roomDetails.map((item, index) =>
					index == selectedRoom &&
					item.childrenVal + 1 <= item.adultCount &&
					item.adultCount + item.childrenVal < 6 &&
					adultCount + childCount + 1 <= 9
						? { ...item, childrenVal: item.childrenVal + 1 }
						: item,
				),
			)
			if (adultCount + childCount < 9 == false) {
				setmaxPeopleAllowed(true)
			}
		} else {
			setinfantCountInvalid(true)
		}
	}
	const decreaseChildFunction = () => {
		roomDetails[selectedRoom].childAges.pop()
		setroomDetails(
			roomDetails.map((item, index) =>
				index == selectedRoom && item.childrenVal >= 1
					? {
							...item,
							childrenVal: item.childrenVal - 1,
					  }
					: item,
			),
		)

		// setroomDetails(roomDetails[selectedRoom].childAges.pop())
		setinfantCountInvalid(false)
		setroomCapacityFull(false)
		setmaxPeopleAllowed(false)
		setchildAgeNotPresent(false)
	}
	const [childrensAgeCount] = useState([
		'<1 Year',
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		10,
		11,
		12,
		13,
		14,
		15,
	])

	const addChildAge = ({ val, inx }) => {
		const vall = [...roomDetails]
		vall[selectedRoom].childAges[inx] = val == '<1 Year' ? 0 : val
		setroomDetails(vall)
	}
	const ondoneFunc = () => {
		const send = { roomDetails, selectetype }
		let childcount = 0,
			childLength = 0
		roomDetails.forEach(element => {
			childcount += element.childrenVal
			childLength += element.childAges.length
		})

		if (childcount == childLength) {
			onchangee(send)
		} else {
			setchildAgeNotPresent(true)
		}
	}
	return (
		<Column className="gcm-room-config" css={{ height: '100%' }}>
			<Column
				align={'center'}
				css={{
					height: '85%',
					borderRadius: '$3',
					overflow: 'scroll',
				}}
			>
				{maxPeopleAllowed ||
				roomCapacityFull ||
				infantCountInvalid ||
				childAgeNotPresent ? (
					<Column
						css={{
							width: '100%',
							backgroundColor: '$red00',
							padding: '$3 0',
						}}
					>
						{maxPeopleAllowed ? (
							<Column justify={'center'} align="center">
								<Text
									css={{
										color: '$red06',
										fontWeight: '$bold',
										fontSize: '$2',
										userSelect: 'none',
									}}
								>
									{ErrorMessage.maxPeopleAllowed}
								</Text>
							</Column>
						) : childAgeNotPresent ? (
							<Column justify={'center'} align="center">
								<Text
									css={{
										color: '$red06',
										fontWeight: '$bold',
										fontSize: '$2',
										textAlign: 'center',
										userSelect: 'none',
									}}
								>
									{ErrorMessage.childAgeNotPresent}
								</Text>
							</Column>
						) : infantCountInvalid ? (
							<Column justify={'center'} align="center">
								<Text
									css={{
										color: '$red06',
										fontWeight: '$bold',
										fontSize: '$2',
										textAlign: 'center',
										userSelect: 'none',
									}}
								>
									{ErrorMessage.infantCountInvalid}
								</Text>
							</Column>
						) : roomCapacityFull ? (
							<Column justify={'center'} align="center">
								<Text
									css={{
										color: '$red06',
										fontWeight: '$bold',
										fontSize: '$2',
										textAlign: 'center',
										userSelect: 'none',
									}}
								>
									{ErrorMessage.roomCapacityFull}
								</Text>
							</Column>
						) : null}
					</Column>
				) : null}
				<Flex
					justify={'center'}
					css={{
						padding: '$5 0 $5 0',
						width: 'calc(70% - 12px)',
						flexWrap: 'wrap',
					}}
				>
					{roomDetails?.map((item, index) => {
						return (
							<Column key={'room-details' + index}>
								<Column
									css={{
										height: 'fit-content',
										marginTop: index === 0 && index === 1 ? 0 : '$4',
										padding: '4px 10px',
										borderBottom:
											selectedRoom === index ? 'solid 2px $black' : 0,
									}}
								>
									<Text
										onClick={() => {
											setselectedRoom(index)
											if (item.adultCount <= 5) {
												setroomCapacityFull(false)
											} else if (item.adultCount >= 6) {
												setroomCapacityFull(true)
											}
										}}
										key={index}
										css={{
											paddingBottom: '$2',
											color: selectedRoom === index ? '$black' : '$grey05',
											cursor: 'pointer',
											fontSize: '$3',
											fontWeight: '$bold',
											userSelect: 'none',
										}}
									>
										Room {index + 1}
									</Text>
								</Column>
							</Column>
						)
					})}
				</Flex>
				<Column align={'center'} css={{ width: '100%', padding: '$2 0' }}>
					{roomDetails?.map((item, index) => {
						return (
							<>
								{index == selectedRoom ? (
									<>
										<Row
											key={'adult' + index}
											justify={'between'}
											align="center"
											css={{ width: '60%' }}
										>
											<Button
												onClick={() => decreaseAdultFunction()}
												css={{
													borderRadius: '$round',
													backgroundColor: 'transparent',
													height: '32px',
													width: '32px',
													boxShadow: 'none',
													borderStyle: 'solid',
													borderWidth: '1px',
													color:
														item.adultCount <= 1
															? 'rgb(204, 204, 204)'
															: '$custom14',
													borderColor:
														item.adultCount <= 1
															? 'rgb(204, 204, 204)'
															: '$custom14',
													pointerEvents:
														infantCountInvalid || childAgeNotPresent
															? 'none'
															: null,
												}}
											>
												-
											</Button>
											<Text css={{ userSelect: 'none' }}>
												{' '}
												{item.adultCount} Adult
											</Text>
											<Button
												onClick={() => addAdultFunction()}
												css={{
													borderRadius: '$round',
													backgroundColor: 'transparent',
													height: '32px',
													width: '32px',
													boxShadow: 'none',
													borderStyle: 'solid',
													borderWidth: '1px',
													color:
														item.adultCount < 1 ||
														item.adultCount >= 6 ||
														roomCapacityFull ||
														infantCountInvalid ||
														maxPeopleAllowed ||
														childAgeNotPresent
															? 'rgb(204, 204, 204)'
															: '$custom14',
													borderColor:
														item.adultCount < 1 ||
														item.adultCount >= 6 ||
														roomCapacityFull ||
														infantCountInvalid ||
														maxPeopleAllowed ||
														childAgeNotPresent
															? 'rgb(204, 204, 204)'
															: '$custom14',
													pointerEvents:
														item.adultCount >= 6 ||
														roomCapacityFull ||
														infantCountInvalid ||
														maxPeopleAllowed ||
														childAgeNotPresent
															? 'none'
															: null,
												}}
											>
												+
											</Button>
										</Row>
										<Row
											justify={'between'}
											align="center"
											css={{ width: '60%', marginTop: '$5' }}
										>
											<Button
												onClick={() => decreaseChildFunction()}
												css={{
													borderRadius: '$round',
													backgroundColor: 'transparent',
													height: '32px',
													width: '32px',
													boxShadow: 'none',
													borderStyle: 'solid',
													borderWidth: '1px',
													color:
														item.adultCount < 1 ||
														item.adultCount >= 6 ||
														item.childrenVal <= 0
															? 'rgb(204, 204, 204)'
															: '$custom14',
													borderColor:
														item.adultCount < 1 ||
														item.adultCount >= 6 ||
														item.childrenVal <= 0
															? 'rgb(204, 204, 204)'
															: '$custom14',
													pointerEvents: item.childrenVal <= 0 ? 'none' : null,
												}}
											>
												-
											</Button>
											<Text css={{ userSelect: 'none' }}>
												{' '}
												{selectedRoom == index ? item.childrenVal : null} Child
											</Text>
											<Button
												onClick={() => addChildFunction()}
												css={{
													borderRadius: '$round',
													backgroundColor: 'transparent',
													height: '32px',
													width: '32px',
													boxShadow: 'none',
													borderStyle: 'solid',
													borderWidth: '1px',
													color:
														item.adultCount < 1 ||
														item.adultCount > 6 ||
														roomCapacityFull ||
														infantCountInvalid ||
														maxPeopleAllowed ||
														childAgeNotPresent
															? 'rgb(204, 204, 204)'
															: '$custom14',
													borderColor:
														item.adultCount < 1 ||
														item.adultCount > 6 ||
														roomCapacityFull ||
														infantCountInvalid ||
														maxPeopleAllowed ||
														childAgeNotPresent
															? 'rgb(204, 204, 204)'
															: '$custom14',
													pointerEvents:
														roomCapacityFull ||
														infantCountInvalid ||
														maxPeopleAllowed ||
														childAgeNotPresent
															? 'none'
															: null,
												}}
											>
												+
											</Button>
										</Row>
										{item.childrenVal >= 1 ? (
											<Column
												justify={'center'}
												align="center"
												css={{
													width: '100%',
													paddingTop: '$5',
												}}
											>
												<Row gap={'1'} justify={'center'}>
													<Baby fill="#999999" />
													<Text
														css={{
															userSelect: 'none',
															color: '$grey06',
															fontSize: '$2',
															fontWeight: '$bold',
															lineHeight: '$2',
														}}
													>
														Child's age
													</Text>
												</Row>
												<Flex
													css={{
														flexWrap: 'wrap',
														width: 'calc(80% - 12px)',
														justifyContent: 'space-evenly',
														paddingTop: '$3',
													}}
												>
													{new Array(item.childrenVal)
														.fill(null)
														.map((i, inx) => {
															return (
																<Popover.Root
																	key={'childage' + inx}
																	open={
																		selectedChildAge.show &&
																		selectedChildAge.selfIndex === inx
																			? selectedChildAge.show
																			: false
																	}
																	onOpenChange={val =>
																		setSelectedChildAge({
																			show: val,
																			roomIndex: selectedRoom,
																			selfIndex: inx,
																		})
																	}
																>
																	<Popover.Trigger asChild>
																		<Row
																			align="center"
																			justify={'between'}
																			css={{
																				padding: '4px 8px 4px 8px',
																				border: '1px solid rgba(0, 0, 0, 0.1)',
																				borderRadius: '4px',
																				height: '36px',
																				width: '40%',
																				marginTop: '$2',
																			}}
																		>
																			<Input
																				placeholder="--"
																				css={{
																					color: '$black',
																					border: 'none',
																					boxShadow: 'none',
																					'&::placeholder': {
																						color: '#42a5f5',
																					},
																					textAlign: 'center',
																				}}
																				value={
																					roomDetails[index].childAges.length
																						? roomDetails[selectedRoom]
																								.childAges[inx] == 0
																							? '<1 Year'
																							: roomDetails[selectedRoom]
																									.childAges[inx]
																						: null
																				}
																			/>
																			<ArrowFillDown
																				fill="rgb(153, 153, 153)"
																				style={{}}
																				fontSize={'16px'}
																			/>
																		</Row>
																	</Popover.Trigger>
																	<Popover.Content
																		css={{
																			height: '250px',
																			width: '90px',
																			backgroundColor: '$white',
																			boxShadow:
																				'rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px',
																			overflow: 'scroll',
																			marginTop: '10px',
																			border: '1px solid $custom14',
																		}}
																	>
																		<Column>
																			{childrensAgeCount.map((val, index) => {
																				return (
																					<Column
																						justify={'center'}
																						key={'childages' + index}
																						onClick={() => {
																							addChildAge({
																								val,
																								inx,
																								index,
																							})
																							setSelectedChildAge({
																								show: false,
																								roomIndex: 0,
																								selfIndex: 0,
																							})
																							setchildAgeNotPresent(false)
																						}}
																						css={{
																							marginTop:
																								index === 0 ? '$2' : '$4',
																							cursor: 'pointer',
																							userSelect: 'none',
																						}}
																					>
																						<Text
																							css={{
																								userSelect: 'none',
																								textAlign: 'center',
																							}}
																						>
																							{val}
																						</Text>
																					</Column>
																				)
																			})}
																		</Column>
																	</Popover.Content>
																</Popover.Root>
															)
														})}
												</Flex>
											</Column>
										) : null}
									</>
								) : null}
							</>
						)
					})}
				</Column>
				<Row
					align={'center'}
					justify="center"
					direction={'row'}
					css={{
						width: '95%',
						marginTop: roomDetails.forEach(element => element.childrenVal > 0)
							? 0
							: '$3',
						paddingBottom: roomDetails.map(e => e.childrenVal > 0)
							? '$5'
							: null,
					}}
				>
					<Divider size={'1'} css={{ backgroundColor: 'rgba(0, 0, 0, 0.1)' }} />
					<Text
						onClick={() => deleteRoomFunction()}
						css={{
							padding: '0 6px 0 6px',
							color:
								roomDetails.length === 1 ? 'rgba(20, 128, 153, 0.3)' : '$red06',
							fontSize: '$1',
							pointerEvents: roomDetails.length === 1 ? 'none' : null,
							cursor: 'pointer',
							fontWeight: '$bold',
							userSelect: 'none',
						}}
					>
						- Delete Room
					</Text>
					<Divider size={'1'} css={{ backgroundColor: 'rgba(0, 0, 0, 0.1)' }} />
					<Text
						onClick={() => {
							if (!infantCountInvalid) {
								addRoomFunction()
							}
						}}
						css={{
							padding: '0 6px 0 6px',
							cursor: 'pointer',
							color:
								roomDetails.length >= 6 ||
								infantCountInvalid ||
								maxPeopleAllowed ||
								roomCapacityFull ||
								childAgeNotPresent
									? 'rgba(20, 128, 153, 0.3)'
									: '$custom14',
							fontWeight: '$bold',
							fontSize: '$2',
							userSelect: 'none',
							pointerEvents:
								roomDetails.length >= 6 ||
								infantCountInvalid ||
								maxPeopleAllowed ||
								roomCapacityFull ||
								childAgeNotPresent
									? 'none'
									: null,
						}}
					>
						+ Add Room
					</Text>
					<Divider size={'1'} css={{ backgroundColor: 'rgba(0, 0, 0, 0.1)' }} />
				</Row>
			</Column>
			<Row
				justify={'between'}
				align="center"
				css={{
					height: '15%',
					boxShadow: 'rgb(48 80 89 / 30%) 0px -1px 10px',
					padding: '0 $4',
				}}
			>
				<Text
					onClick={() => onCloseModal({ eventclose: false })}
					css={{
						cursor: 'pointer',
						color: '$custom17',
						'@hover': { color: 'hsla(0,0%,46.7%,.8)' },
						fontWeight: '$extrabold',
						userSelect: 'none',
					}}
				>
					Cancel
				</Text>
				<Text
					onClick={() => ondoneFunc()}
					css={{
						cursor: 'pointer',
						color: '$custom14',
						'@hover': { color: '$custom16' },
						fontWeight: '$extrabold',
						userSelect: 'none',
					}}
				>
					Done
				</Text>
			</Row>
		</Column>
	)
}
export default TravelDetailRoom
